import { gql } from '@apollo/client';

export default gql`
  mutation UpdateReportJob($id: Int!, $reportJobPatch: ReportJobPatch!) {
    updateReportJobById(input: { id: $id, reportJobPatch: $reportJobPatch }) {
      clientMutationId
    }
  }
`;
